// src/pages/employer/EmployerCandidates.jsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { jobAdAPI } from '../../services/api';

const BAND_COLOURS = {
  EXCELLENT: '#28A745',
  GOOD:      '#3D80CC',
  FAIR:      '#E6A817',
  POOR:      '#CC0000',
};

const ScorePill = ({ score, band }) => (
  <span style={{
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 700,
    color: '#fff',
    background: BAND_COLOURS[band] || '#999',
    minWidth: 44,
    textAlign: 'center',
  }}>
    {Math.round(score)}%
  </span>
);

export const EmployerCandidates = () => {
  const { activeOrg, activeProfile } = useAuth();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeOrg || !activeProfile) return;
    jobAdAPI.getCandidates(activeOrg.id, activeProfile.id)
      .then(({ data }) => setMatches(data.data.matches || []))
      .finally(() => setLoading(false));
  }, [activeOrg, activeProfile]);

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>Candidates</h1>
        <p>{matches.length} match{matches.length !== 1 ? 'es' : ''} found</p>
      </div>

      {loading ? (
        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 4, padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
          Loading...
        </div>
      ) : matches.length === 0 ? (
        <div style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 4, padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>
          No candidates have applied yet.
        </div>
      ) : (
        <div className="section-box">
          <div className="section-box-header">All Candidates</div>
          <div className="section-box-body" style={{ padding: 0 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f5f5f5', textAlign: 'left' }}>
                  <th style={{ padding: '10px 14px', fontWeight: 700, color: '#555' }}>Position</th>
                  <th style={{ padding: '10px 14px', fontWeight: 700, color: '#555' }}>Candidate</th>
                  <th style={{ padding: '10px 14px', fontWeight: 700, color: '#555', textAlign: 'center' }}>Score</th>
                  <th style={{ padding: '10px 14px', fontWeight: 700, color: '#555', textAlign: 'center' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {matches.map(m => {
                  const seeker = m.jobSeeker || {};
                  const posName = m.adPosition?.jobDefinition?.name || 'Position';
                  return (
                    <tr
                      key={m.id}
                      onClick={() => navigate(`/employer/candidates/${m.id}`)}
                      style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
                      onMouseLeave={e => e.currentTarget.style.background = ''}
                    >
                      <td style={{ padding: '10px 14px', fontWeight: 600, color: '#333' }}>{posName}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <div style={{ color: '#333' }}>
                          {seeker.firstName} {seeker.lastName}
                        </div>
                        {seeker.city && (
                          <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                            {seeker.city}{seeker.country ? `, ${seeker.country}` : ''}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                        <ScorePill score={m.totalScore} band={m.matchBand} />
                      </td>
                      <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                        <span className={`tag ${m.status === 'SHORTLISTED' ? 'tag-green' : m.status === 'REJECTED' ? 'tag-red' : 'tag-ghost'}`}>
                          {m.status}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};
